import { Stack, Typography } from '@mui/material';

import React, { useEffect, useState } from 'react';

import { ReactComponent as Person } from 'common/assets/images/person.svg';
import ChipComponent from 'common/components/Chip/Chip';
import { RISK_LINK_CONFIG_TYPE } from 'common/constants/AskRiskLinkConstants';
import { HTTP_STATUS_CODES } from 'common/constants/HttpStatusConstants';

import { getUserPromptsConfig } from '../api';
import { IUserPromptsConfig } from '../api/type-def';

import PromptList from './PromptList';

import styles from './PromptLibrary.module.scss';

interface IPromptLibrary {
	setSearchVal: (value: string, role: string) => void;
	setCursorPosition: any;
}

const PromptLibrary = (props: IPromptLibrary) => {
	const { setCursorPosition, setSearchVal } = props;
	const [roles, setRoles] = useState<IUserPromptsConfig[]>([]);
	const [role, setRole] = useState<string | null>(null);
	const { ROLE } = RISK_LINK_CONFIG_TYPE;
	const { OK } = HTTP_STATUS_CODES;

	const getAskRiskLinkRoles = async () => {
		const response = await getUserPromptsConfig(ROLE);
		if (response.responseBody && response.statusCode === OK) {
			const data = response.responseBody as IUserPromptsConfig[];
			setRoles(data);
		}
	};

	useEffect(() => {
		getAskRiskLinkRoles();
	}, []);

	const roleChangeHandler = (changedRole: string) => {
		if (role === changedRole) {
			setRole(null);
		} else {
			setRole(changedRole);
		}
	};
	return (
		<>
			<div>
				<Stack
					direction="row"
					alignItems="center"
					spacing={1}
					className={styles['role-header']}
				>
					<Typography className={styles['header-style']}>
						Choose a role
					</Typography>
					<Person />
				</Stack>
				<Stack direction="row" spacing={2} className={styles['role-container']}>
					{roles.map((ele) => (
						<ChipComponent
							label={ele.name}
							key={ele.name}
							defaultClass
							className={
								styles[
									role === ele.name ? 'role-enabled-type' : 'role-disabled-type'
								]
							}
							onClick={() => roleChangeHandler(ele.name)}
						/>
					))}
				</Stack>
			</div>
			<PromptList
				selectedRole={role}
				setSearchVal={setSearchVal}
				setCursorPosition={setCursorPosition}
			/>
		</>
	);
};

export default PromptLibrary;
